import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';

import { AuthService } from 'src/app/core';

import { AdminMenuItems } from './admin-menu-items';

@Component({
	selector: 'app-private-header',
	templateUrl: './private-header.component.html',
	styleUrls: ['./private-header.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class AdminHeaderComponent implements OnInit {

	get isUserLogged(): boolean {
		return this.authService.isAuthenticated;
	}

	public logOut = async () => {
		await this.authService.logout();
	}

	get profileAvatar(): SafeResourceUrl {
		return this.authService.getProfileAvatar;
	}

	get profileName(): string {
		return this.authService.getProfileName;
	}

	constructor(public adminMenuItems: AdminMenuItems, private authService: AuthService) { }

	ngOnInit() { }
}
